var Constants = (function () {
    function Constants() {
    }
    Constants.EventAggregator = 'eventAggregator';
    Constants.ViewManager = 'viewManager';
    Constants.ViewResolver = 'viewResolver';
    Constants.ModelResolver = 'modelResolver';
    Constants.Server = 'server';
    Constants.Library = 'library';
    Constants.Buffer = 'buffer';
    Constants.Action = 'action';
    Constants.Invoker = 'invoker';
    Constants.NotifyBuffer = 'notifyBuffer';
    Constants.UrlResolver = 'urlResolver';
    Constants.ModelFactory = 'modelFactory';
    Constants.ModalFactory = 'modalFactory';
    Constants.RequestBuilder = 'requestBuilder';
    Constants.DeltaHandler = 'deltaHandler';
    Constants.TypeService = 'typeService';
    Constants.WorkQueue = 'workQueue';
    Constants.CommandWorker = 'commandWorker';
    Constants.CommandFactory = 'commandFactory';
    return Constants;
}());
export { Constants };
var ContentType = (function () {
    function ContentType() {
    }
    ContentType.applicationJson = 'application/json;charset=utf-8';
    ContentType.multipartFormdata = 'multipart/form-data';
    return ContentType;
}());
export { ContentType };
var Events = (function () {
    function Events() {
    }
    Events.Change = 'change';
    Events.ActionComplete = 'actionComplete';
    Events.ActionError = 'actionError';
    Events.ActionSending = 'ActionSending';
    Events.ApplyDeltas = 'applyDeltas';
    Events.Error = 'error';
    Events.AddToWorkQueue = 'addToWorkQueue';
    Events.ExecWorkQueue = 'execToWorkQueue';
    Events.PreActionCommandGeneratorRegistration = 'preActionCommandGeneratorRegistration';
    Events.PreActionCommandGeneratorDeregistration = 'preActionCommandGeneratorDeregistration';
    Events.ApplicationRestart = 'applicationRestart';
    Events.ReloadPendingViews = 'reloadPendingViews';
    Events.SetDMText = 'setDMText';
    Events.DeletePendingActions = 'DeletePendingActions';
    Events.ArrangeWindow = 'arrangeWindow';
    Events.GridPrint = 'gridPrint';
    Events.StylesChanged = 'stylesChanged';
    Events.UpdateRanges = 'updateRanges';
    Events.ModalExecution = 'modalExecution';
    Events.ApplyMultipleTab = 'multipleTab';
    Events.DesktopAgentClientPrinters = 'desktopAgentClientPrinters';
    Events.DesktopAgentPrintFile = 'desktopAgentPrintFile';
    return Events;
}());
export { Events };
export var Resolve;
(function (Resolve) {
    Resolve[Resolve["Singleton"] = 0] = "Singleton";
    Resolve[Resolve["Request"] = 1] = "Request";
})(Resolve || (Resolve = {}));
